/* ============================================================
   dn-novia.js — Flujo guiado "Día de la Novia" (Serené)
   Paso 1: elegir 2 x 100 ml
   Paso 2: elegir 1 x 50 ml de regalo (bloqueado hasta completar paso 1)
   Selección 100% cliente -> se agrega al carrito solo al finalizar.
   Namespace dn-  ·  Aislado de gs-*  ·  No colisiona IDs/JS.
   ============================================================ */
(function () {
  'use strict';
  if (window.__dnNoviaLoaded) return;
  window.__dnNoviaLoaded = true;

  var SKEY = 'dn_novia_sel_v1';
  // Código de descuento de PEDIDO (50% de la 2da 100ml). Se "arma" en segundo
  // plano durante el flujo para que combine con el regalo automático (clases
  // distintas: pedido + producto). Requiere el código creado en Admin.
  var DN_CODE = 'NOVIA2DA-SERENE';
  var state = { buy: [], gift: null };   // buy: [vid,...]  gift: vid|null
  var needBuy = 2;

  /* ---------- persistencia ---------- */
  function load() {
    try {
      var raw = sessionStorage.getItem(SKEY);
      if (raw) {
        var o = JSON.parse(raw);
        if (o && Array.isArray(o.buy)) state.buy = o.buy.map(String);
        if (o && o.gift) state.gift = String(o.gift);
      }
    } catch (e) {}
  }
  function save() {
    try { sessionStorage.setItem(SKEY, JSON.stringify(state)); } catch (e) {}
  }

  /* ---------- helpers DOM ---------- */
  function stepEl(role) { return document.querySelector('[data-dn-step][data-role="' + role + '"]'); }
  function cardsOf(role) {
    var s = stepEl(role);
    return s ? Array.prototype.slice.call(s.querySelectorAll('[data-dn-card]')) : [];
  }
  function cardByVid(role, vid) {
    return cardsOf(role).filter(function (c) { return c.getAttribute('data-vid') === String(vid); })[0] || null;
  }
  function isAvail(card) { return card && card.getAttribute('data-available') === 'true'; }

  function toast(msg) {
    var t = document.querySelector('[data-dn-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-show');
    clearTimeout(t.__dnT);
    t.__dnT = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  /* ---------- validar selección contra el DOM actual ---------- */
  function reconcile() {
    // buy: descartar vids que ya no existen o están agotados
    state.buy = state.buy.filter(function (vid) {
      var c = cardByVid('buy', vid);
      return c && isAvail(c);
    }).slice(0, needBuy);
    // gift
    if (state.gift) {
      var g = cardByVid('gift', state.gift);
      if (!g || !isAvail(g)) state.gift = null;
    }
  }

  /* ---------- render de estados ---------- */
  function buyComplete() { return state.buy.length >= needBuy; }
  function allComplete() { return buyComplete() && !!state.gift; }

  function paintCards() {
    // BUY
    cardsOf('buy').forEach(function (card) {
      var vid = card.getAttribute('data-vid');
      var sel = state.buy.indexOf(vid) !== -1;
      card.classList.toggle('is-selected', sel);
      var btn = card.querySelector('[data-dn-select]');
      if (!isAvail(card)) return;
      if (btn) btn.textContent = sel ? 'Elegido ✓' : 'Elegir';
    });
    // GIFT
    var locked = !buyComplete();
    var giftStep = stepEl('gift');
    if (giftStep) {
      var lockbar = giftStep.querySelector('[data-dn-lockbar]');
      if (lockbar) lockbar.hidden = !locked;
    }
    cardsOf('gift').forEach(function (card) {
      var vid = card.getAttribute('data-vid');
      var sel = state.gift === vid;
      card.classList.toggle('is-selected', sel);
      card.classList.toggle('is-locked', locked && isAvail(card));
      var btn = card.querySelector('[data-dn-select]');
      if (!isAvail(card)) return;
      if (btn) btn.textContent = sel ? 'Regalo elegido ✓' : 'Elegir mi regalo';
    });
  }

  function paintCounters() {
    document.querySelectorAll('[data-dn-counter]').forEach(function (el) {
      var role = el.getAttribute('data-role');
      var txt = el.querySelector('[data-dn-counter-text]');
      if (role === 'buy') {
        var n = state.buy.length;
        el.setAttribute('data-state', n >= needBuy ? 'done' : 'pending');
        if (txt) txt.textContent = n >= needBuy ? '¡Listo! Elegiste tus 2 perfumes ✓' : (n + ' de ' + needBuy + ' elegidos');
      } else {
        if (!buyComplete()) {
          el.setAttribute('data-state', 'locked');
          if (txt) txt.textContent = 'Bloqueado — primero elige 2 de 100 ml';
        } else if (state.gift) {
          el.setAttribute('data-state', 'done');
          if (txt) txt.textContent = '¡Regalo elegido! ✓';
        } else {
          el.setAttribute('data-state', 'pending');
          if (txt) txt.textContent = 'Elige 1 perfume de 50 ml';
        }
      }
    });
  }

  function paintSummary() {
    var buyVal = document.querySelector('[data-dn-sum-val="buy"]');
    var giftVal = document.querySelector('[data-dn-sum-val="gift"]');
    var buyItem = document.querySelector('[data-dn-sum="buy"]');
    var giftItem = document.querySelector('[data-dn-sum="gift"]');
    var discItem = document.querySelector('[data-dn-sum="disc"]');
    if (buyVal) {
      var names = state.buy.map(function (vid) {
        var c = cardByVid('buy', vid);
        return c ? c.getAttribute('data-title') : '';
      }).filter(Boolean);
      buyVal.textContent = names.length ? names.join('  ·  ') : 'Aún no seleccionados';
    }
    if (giftVal) {
      var g = state.gift ? cardByVid('gift', state.gift) : null;
      giftVal.textContent = g ? g.getAttribute('data-title') : 'Aún no seleccionado';
    }
    if (buyItem) buyItem.classList.toggle('is-done', buyComplete());
    if (discItem) discItem.classList.toggle('is-done', buyComplete());
    if (giftItem) giftItem.classList.toggle('is-done', !!state.gift);
  }

  function paintSticky() {
    var status = document.querySelector('[data-dn-status]');
    var txt = document.querySelector('[data-dn-status-text]');
    var cta = document.querySelector('[data-dn-checkout]');
    var msg;
    if (!buyComplete()) {
      var falta = needBuy - state.buy.length;
      msg = 'Te falta elegir ' + falta + ' perfume' + (falta === 1 ? '' : 's') + ' de 100 ml.';
    } else if (!state.gift) {
      msg = 'Desliza abajo para elegir tu regalo 🎁';
    } else {
      msg = 'Tu promoción está completa.';
    }
    if (txt) txt.textContent = msg;
    if (status) status.classList.toggle('is-done', allComplete());
    if (cta) cta.disabled = !allComplete();
  }

  function paintAll() { paintCards(); paintCounters(); paintSummary(); paintSticky(); }

  /* ---------- interacción ---------- */
  function scrollToGift() {
    var g = stepEl('gift');
    if (!g) return;
    setTimeout(function () {
      try { g.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      catch (e) { g.scrollIntoView(); }
    }, 120);
  }

  function onSelect(card) {
    var role = card.getAttribute('data-role');
    var vid = card.getAttribute('data-vid');
    if (!isAvail(card)) { toast('Este perfume está agotado.'); return; }

    var wasBuyComplete = buyComplete();     // estado previo (para detectar la transición)

    if (role === 'buy') {
      var i = state.buy.indexOf(vid);
      if (i !== -1) {
        state.buy.splice(i, 1);           // deseleccionar
        if (state.gift) toast('Quitaste un perfume. Elige otro para volver a cumplir la promoción.');
      } else if (state.buy.length >= needBuy) {
        toast('Ya elegiste tus 2 perfumes. Deselecciona uno para cambiarlo.');
        return;
      } else {
        state.buy.push(vid);
        if (buyComplete()) toast('¡Listo! Ahora elige tu regalo de 50 ml. 🎁');
      }
    } else { // gift
      if (!buyComplete()) {
        var falta = needBuy - state.buy.length;
        toast('Te falta elegir ' + falta + ' perfume' + (falta === 1 ? '' : 's') + ' de 100 ml.');
        return;
      }
      if (state.gift === vid) {
        state.gift = null;                 // deseleccionar
      } else {
        if (state.gift) toast('Solo puedes elegir 1 perfume de 50 ml gratis. Cambiamos tu regalo.');
        state.gift = vid;                  // radio: reemplaza (máx 1)
      }
    }
    save();
    paintAll();

    // Al completar la promo (elegir el regalo que cierra 2+1) → agregar al
    // carrito y desplegar el cart-drawer lateral automáticamente.
    if (allComplete()) {
      var trigBtn = card.querySelector('[data-dn-select]');
      syncCartAndOpenDrawer(trigBtn);
    } else if (!wasBuyComplete && buyComplete() && !state.gift) {
      // Acaba de elegir su 2da fragancia de 100 ml (aún sin regalo) →
      // llevarlo suave a la sección de 50 ml para elegir el regalo.
      scrollToGift();
    }
  }

  function bind() {
    document.querySelectorAll('[data-dn-card]').forEach(function (card) {
      if (card.__dnBound) return;
      card.__dnBound = true;
      var btn = card.querySelector('[data-dn-select]');
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); onSelect(card); });
    });
  }

  /* ---------- carrito + cart-drawer lateral (patrón validado del tema) ---------- */
  var cartBusy = false;

  function cartJson() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // "Arma" el código de descuento de pedido (setea la cookie de descuento).
  // Resuelve siempre (aunque falle) para no bloquear el add al carrito.
  function armCode() {
    if (!DN_CODE) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(DN_CODE) + '?redirect=/cart', { credentials: 'same-origin' })
      .then(function () {}, function () {});
  }

  // Dedupe: quita nuestras propias líneas de promo (line property _dn_novia)
  // para no acumular duplicados si el cliente cambia el regalo. NO toca los
  // demás productos del carrito del cliente.
  function clearPromoLines() {
    return cartJson().then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (li) {
        if (li.properties && li.properties._dn_novia) updates[li.key] = 0;
      });
      if (!Object.keys(updates).length) return null;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    });
  }

  // Refresca cart-icon-bubble + cart-drawer con el HTML server-rendered.
  // CRÍTICO: NO sobrescribir el className del <cart-drawer> — solo togglear
  // is-empty y reemplazar innerHTML (preserva la clase 'active' de apertura).
  function updateDrawerSections(sections) {
    if (!sections) return;
    try {
      if (sections['cart-icon-bubble']) {
        var pB = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var tB = document.getElementById('cart-icon-bubble');
        var sB = pB.querySelector('#shopify-section-cart-icon-bubble') || pB.querySelector('.shopify-section');
        if (tB && sB) tB.innerHTML = sB.innerHTML;
      }
      if (sections['cart-drawer']) {
        var pD = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var tD = document.querySelector('cart-drawer');
        var sD = pD.querySelector('cart-drawer');
        if (tD && sD) {
          tD.classList.toggle('is-empty', sD.classList.contains('is-empty'));
          tD.innerHTML = sD.innerHTML;
        }
      }
    } catch (e) {}
  }

  function openDrawer(trigger) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(trigger || undefined); return true; }
    return false;
  }

  // Sincroniza el carrito con la selección (2×100ml + 1×50ml) y abre el drawer.
  function syncCartAndOpenDrawer(trigger) {
    if (cartBusy) return;
    if (!allComplete()) { toast('Completa tus selecciones para continuar.'); return; }
    cartBusy = true;
    var cta = document.querySelector('[data-dn-checkout]');
    if (cta) cta.classList.add('is-loading');

    var items = state.buy.map(function (vid) {
      return { id: Number(vid), quantity: 1, properties: { _dn_novia: '1' } };
    });
    items.push({ id: Number(state.gift), quantity: 1, properties: { _dn_novia: '1' } });

    armCode()
      .then(function () { return clearPromoLines(); })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: 'cart-icon-bubble,cart-drawer',
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'add_error'); });
        return r.json();
      })
      .then(function (data) {
        if (data.sections) updateDrawerSections(data.sections);
        var opened = openDrawer(trigger);
        if (!opened) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        if (cta) cta.classList.remove('is-loading');
        cartBusy = false;
      })
      .catch(function (err) {
        if (cta) cta.classList.remove('is-loading');
        cartBusy = false;
        toast('No pudimos agregar los productos. Intenta de nuevo.');
        if (window.console) console.warn('[dn-novia] cart error:', err);
      });
  }

  /* ---------- mover la barra sticky al final del body (stacking seguro) ---------- */
  function relocateSticky() {
    var bar = document.querySelector('[data-dn-sticky]');
    if (bar && bar.parentElement !== document.body) document.body.appendChild(bar);
    var toastEl = document.querySelector('[data-dn-toast]');
    if (toastEl && toastEl.parentElement !== document.body) document.body.appendChild(toastEl);
  }

  // Al (re)ENTRAR a la pagina sin haber comprado: deja el carrito limpio de la
  // promo previa -> quita el codigo de descuento y las lineas _dn_novia que
  // hayan quedado de una sesion anterior abandonada. El descuento se vuelve a
  // armar solo cuando el cliente completa el 2+1 de nuevo.
  function resetPromoOnEntry() {
    return cartJson().then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (li) {
        if (li.properties && li.properties._dn_novia) updates[li.key] = 0;
      });
      function post(body) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      }
      // Dos llamadas separadas: combinar discount + updates hace que Shopify
      // ignore las lineas. Primero limpia el codigo, luego quita las lineas.
      return post({ discount: '' }).then(function () {
        if (Object.keys(updates).length) return post({ updates: updates });
      });
    }).then(function () {}, function () {});
  }

  /* ---------- init ---------- */
  function init() {
    var anyStep = stepEl('buy') || stepEl('gift');
    if (!anyStep) return;                 // no estamos en la plantilla día-novia
    var bs = stepEl('buy');
    if (bs) needBuy = parseInt(bs.getAttribute('data-need'), 10) || 2;

    relocateSticky();
    resetPromoOnEntry();
    load();
    reconcile();
    bind();
    paintAll();

    var cta = document.querySelector('[data-dn-checkout]');
    if (cta && !cta.__dnBound) { cta.__dnBound = true; cta.addEventListener('click', function () { syncCartAndOpenDrawer(cta); }); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor: re-enganchar tras recargar una sección
  document.addEventListener('shopify:section:load', function () { bind(); paintAll(); });
})();
